import { render, staticRenderFns } from "./AmColumnWithRoutatedSeries.vue?vue&type=template&id=2fb54016&scoped=true&"
import script from "./AmColumnWithRoutatedSeries.vue?vue&type=script&lang=js&"
export * from "./AmColumnWithRoutatedSeries.vue?vue&type=script&lang=js&"
import style0 from "./AmColumnWithRoutatedSeries.vue?vue&type=style&index=0&id=2fb54016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb54016",
  null
  
)

export default component.exports